import { FETCH_HELP_TILE_CONTENT } from '../types'
export default (state = null, action) => {
  switch (action.type) {
    case FETCH_HELP_TILE_CONTENT:
      return action.payload
    default:
      return state;
  }
}